import { render, staticRenderFns } from "./PersonPerformanceConfirmDetail.vue?vue&type=template&id=fa493762&scoped=true&"
import script from "./PersonPerformanceConfirmDetail.vue?vue&type=script&lang=js&"
export * from "./PersonPerformanceConfirmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa493762",
  null
  
)

export default component.exports